import { render, staticRenderFns } from "./base-radio.vue?vue&type=template&id=236424fb&scoped=true"
import script from "./base-radio.vue?vue&type=script&lang=ts"
export * from "./base-radio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236424fb",
  null
  
)

export default component.exports